import React, { Component } from 'react';
import { FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Button } from '@mui/material';

const filterSpacingStyle = { /* width: '100%',*/ marginRight: '2rem' };

class ButtonInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange = (newValue) => {
    this.props.onChanged(
      {
        [this.props.settings.key]: newValue,
      },
      this.props.settings
    );
  };

  render() {
    return (
      <FormControl
        variant="standard"
        component="fieldset"
        style={filterSpacingStyle}
        data-qa={`qa-rbFilter-${this.props.settings.name}`}
      >
        <FormLabel component="label">
          <p style={{ fontSize: '75%' }}>{this.props.settings.displayName}</p>
        </FormLabel>
        {this.props.settings.options.map((option, index) => (
          <Button
            key={index}
            variant="contained"
            onClick={() => this.onChange(option.value)}
            color={option.color || 'primary'}
            data-qa={`qa-${option.value}`}
          >
            {option.name}
          </Button>
        ))}
      </FormControl>
    );
  }
}

export default ButtonInput;
